import module from '../module';
import moment from 'moment';
import * as _ from 'lodash';
import scopeUtils from '../../../utils/scope';


class OrderHistoryDirectiveController {
    static $inject = [ '$scope', 'OrderHistoryService' ];

    constructor(scope, orderHistoryService) {

        this._scope = scope;
        this._orderHistoryService = orderHistoryService;
        this._scope.viewDetails = id => this._viewDetails(id);
        this._scope.closeDetails = () => this._scope.orderDetails = null;
        this._scope.orderDetails = null;
        this._scope.history = [];
        this._initialize();
    }

    async _initialize() {

        const history = await this._orderHistoryService.getHistory();
        this._scope.history = history;

        _.each(history, function (item) {
            item.orderedFormatted = moment(item.orderedOn).format('H:mm A dddd, MMMM DD, YYYY');
            item.expectedFormatted = moment(item.expectedOn).format('MMMM DD, YYYY');
            item.address = item.shippingAddress + (item.shippingAddress2 ? ' ' + item.shippingAddress2 : '') + ', ' + item.shippingCity + ', ' + item.shippingState + ' ' + item.shippingZip;
        });

        scopeUtils.apply(this._scope);
    }

    async _viewDetails(id) {
        this._scope.orderDetails = _.find(this._scope.history, function (item) {
            return item.orderId === id;
        });
        scopeUtils.apply(this._scope);
    }
}

module.directive('orderHistory', function () {
    return {
        scope: true,
        templateUrl: 'modules/profile/views/orderHistory.html',
        controller: OrderHistoryDirectiveController
    };
});




// WEBPACK FOOTER //
// ./src/modules/profile/directives/OrderHistoryDirective.js